















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class VDeleteModal extends Vue {
  @Prop({ type: String, default: () => "本当に削除しますか？" })
  content!: String;

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }
}
